<template>
    <el-container direction="vertical" class="spreadsheet">
        <el-row type="flex" align="middle" class="spreadsheet-header" justify="space-between">
            <el-col :span="15">
                <div class="spreadsheet-header-title">
                    {{ title }}
                </div>
                <div class="spreadsheet-header-filter-info">
                    <span class="spreadsheet-header-filter-info_black">
                        Поиск по:
                    </span>
                    <span class="spreadsheet-header-filter-info_gray" v-if="isAllTaskFilterPresetSet">
                        {{ filterTitle }}
                    </span>
                </div>
            </el-col>
            <el-col :span="2">
                <el-popover
                    popper-class="grid-search-dialog"
                    placement="top"
                    width="293"
                    trigger="click"
                    v-model="isFilterFormVisible"
                >
                    <el-button slot="reference" class="spreadsheet-header-button" :type="isAllTaskFilterPresetSet ? 'warning' : 'info'" :disabled="!isAllTaskFilterPresetSet">
                        поиск
                    </el-button>
                    <el-form label-position="top" @keyup.enter.native="filterApplied">
                        <el-form-item :label="fieldsNames.id" :label-width="formLabelWidth" v-if="isColumnVisible('id')">
                            <el-input v-model="filterModel.id" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.status_id" :label-width="formLabelWidth" v-if="isColumnVisible('status_id')">
                            <el-select
                                v-model="filterModel.status_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.status_id"
                                size="mini"
                            >
                                <el-option v-for="item in status" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.title" :label-width="formLabelWidth" v-if="isColumnVisible('title')">
                            <el-input v-model="filterModel.title" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.contact_name" :label-width="formLabelWidth" v-if="isColumnVisible('contact.name')">
                            <el-input v-model="filterModel.contact_name" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.contact_phone" :label-width="formLabelWidth" v-if="isColumnVisible('contact.phone')">
                            <el-input v-model="filterModel.contact_phone" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.assigned_user_id" :label-width="formLabelWidth" v-if="isColumnVisible('assigned_user_id')">
                            <el-select
                                v-model="filterModel.assigned_user_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.assigned_user_id"
                                size="mini"
                            >
                                <el-option v-for="item in employers" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.planned" :label-width="formLabelWidth" v-if="isColumnVisible('planned')">
                            <el-date-picker
                                v-model="filterModel.planned"
                                type="daterange"
                                start-placeholder="дата"
                                end-placeholder="дата"
                                clearable
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                size="mini"
                                class="w100"
                                :picker-options="pickerOptions"
                            />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.related_entity_id" :label-width="formLabelWidth" v-if="isColumnVisible('related_entity_id')" type="number">
                            <el-input v-model="filterModel.related_entity_id" autocomplete="off" size="mini" clearable />
                        </el-form-item>
                        <el-form-item :label="fieldsNames.created_user_id" :label-width="formLabelWidth" v-if="isColumnVisible('created_user_id')">
                            <el-select
                                v-model="filterModel.created_user_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                multiple
                                collapse-tags
                                clearable
                                :placeholder="fieldsNames.created_user_id"
                                size="mini"
                            >
                                <el-option v-for="item in employers" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-form-item>
                        <el-form-item :label="fieldsNames.finished" :label-width="formLabelWidth" v-if="isColumnVisible('finished')">
                            <el-date-picker
                                v-model="filterModel.finished"
                                type="datetimerange"
                                range-separator="по"
                                start-placeholder="дата время"
                                end-placeholder="дата время"
                                clearable
                                format="dd.MM.yyyy HH:mm"
                                value-format="dd.MM.yyyy HH:mm"
                                size="mini"
                                class="w100"
                                :picker-options="pickerOptions"
                            />
                        </el-form-item>
                    </el-form>
                    <div class="popover-footer">
                        <el-button @click="hideFilterForm">
                            Отменить
                        </el-button>
                        <el-button type="warning" @click="filterApplied">
                            Применить
                        </el-button>
                    </div>
                </el-popover>
            </el-col>
            <el-col :span="3">
                <span class="spreadsheet-header-total">
                    Всего записей: {{ pagesInfo.total }}
                </span>
            </el-col>
            <el-col :span="3">
                <el-button class="spreadsheet-header-button" type="warning" @click="goNewCard">
                    новая задача
                </el-button>
            </el-col>
            <el-col :span="1" title="Excel" class="icon-excel" v-if="isExcelButtonVisible">
                <div class="spreadsheet-header-excel">
                    &nbsp;
                </div>
            </el-col>
        </el-row>
        <el-row type="flex" align="top" class="spreadsheet-table" v-loading="loading">
            <el-col :span="24">
                <ag-grid-vue
                    class="ag-theme-balham spreadsheet-table-grid"
                    :grid-options="gridOptions"
                    :column-defs="columnDefs"
                />
            </el-col>
        </el-row>
        <el-row type="flex" align="bottom" class="spreadsheet-bar">
            <el-col :span="6">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="pagesInfo.total"
                    :page-size="pageModel.pageSize"
                    :current-page="pageModel.currentPage"
                    :small="true"
                    @current-change="getCurrentPage"
                />
            </el-col>
            <el-col :span="9">
                <div class="spreadsheet-bar-pages">
                    <span class="spreadsheet-bar-pages-title">
                        Выводить по:
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize20}"
                        @click="setPageSize(20)"
                    >
                        20
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize50}"
                        @click="setPageSize(50)"
                    >
                        50
                    </span>
                    <span
                        class="spreadsheet-bar-pages-size"
                        :class="{'is-active': isSetPageSize100}"
                        @click="setPageSize(100)"
                    >
                        100
                    </span>
                </div>
            </el-col>
            <el-col :span="9">
                <div class="spreadsheet-bar-total">
                    <span>
                        Строк выведено: {{ totalRows }} Из них выделено: {{ selectedRowsCount }}
                    </span>
                </div>
            </el-col>
        </el-row>
    </el-container>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import TableHeaderSettings from '@/components/TableHeaderSettings';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import capitalize from 'lodash/capitalize';
import moment from 'moment';
import '@/assets/styles/list.scss';
import localReferences from '@/helpers/localReferences';
import { pickerOptions } from '@/common/pickerOptions';

library.add(faEye);

const initialFilterModel = {
    id: null,
    status_id: [],
    title: null,
    assigned_user_id: [],
    planned: [],
    related_entity_id: null,
    created_user_id: [],
    finished: [],
    contact_name: null,
    contact_phone: null
};

export default {
    name: 'TasksGrid',
    data() {
        return {
            title: 'Список задач',
            isFilterFormVisible: false,
            filterPresets: [
                {
                    alias: 'all',
                    title: 'все',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.employerId],
                        status_id: [localReferences.taskStatuses.assigned, localReferences.taskStatuses.onCheck]
                    }
                },
                {
                    alias: 'overdue',
                    title: 'просроченные',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.employerId],
                        status_id: [localReferences.taskStatuses.assigned],
                        planned: [null, moment().subtract(1, 'days').endOf('day').format('D.MM.YYYY')]
                    }
                },
                {
                    alias: 'today',
                    title: 'сегодня',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.employerId],
                        status_id: [localReferences.taskStatuses.assigned],
                        planned: [moment().startOf('day').format('D.MM.YYYY'), moment().endOf('day').format('D.MM.YYYY')]
                    }
                },
                {
                    alias: 'tomorrow',
                    title: 'завтра',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.employerId],
                        status_id: [localReferences.taskStatuses.assigned],
                        planned: [moment().add(1, 'days').startOf('day').format('D.MM.YYYY'), null]
                    }
                },
                {
                    alias: 'timeless',
                    title: 'без срока',
                    filter: {
                        assigned_user_id: [this.$store.state.auth.employerId],
                        status_id: [localReferences.taskStatuses.assigned, localReferences.taskStatuses.onCheck],
                        planned: ['NULL', 'NULL']
                    }
                }
            ],
            filterModel: { ...initialFilterModel },
            fieldsNames: {
                id: 'id',
                status_id: 'статус',
                status: 'статус',
                priority: 'приоритет',
                title: 'название',
                assigned_user_id: 'исполнитель',
                planned: 'срок',
                related_entity_id: 'сделка',
                created_user_id: 'постановщик',
                finished: 'дата время завершения',
                contact_name: 'имя контакта',
                contact_phone: 'телефон контакта',
                entity_address: 'адрес'
            },
            sortModel: {},
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            formLabelWidth: '120px',
            totalRows: 0,
            selectedRowsCount: 0,
            loading: true,
            pickerOptions,
            gridOptions: {
                rowSelection: 'multiple',
                suppressDragLeaveHidesColumns: false,
                suppressPaginationPanel: true,
                suppressLoadingOverlay: true,
                rowDeselection: true,
                enableCellTextSelection: true,
                headerHeight: 50,
                rowHeight: 40,
                domLayout: 'autoHeight',
                onRowDataChanged: this.onRowDataChanged.bind(this),
                onRowSelected: this.onRowSelected.bind(this),
                onColumnResized: this.onColumnResized.bind(this),
                onDisplayedColumnsChanged: this.onDisplayedColumnsChanged.bind(this),
                onRowDoubleClicked: this.onSelectionChanged.bind(this),
                onSortChanged: this.onSortChanged.bind(this),
                onRowClicked: this.onRowClicked.bind(this),
                defaultColDef: {
                    sortable: true,
                    filter: false,
                    resizable: true,
                    comparator: () => {
                        return 0;
                    },
                    cellClass: 'column-text pointer'
                }
            },
            columnDefs: []
        };
    },
    components: {
        AgGridVue
    },
    computed: {
        tasks() {
            return this.$store.state.tasks.tasks;
        },
        pagesInfo() {
            return this.$store.state.tasks.pages;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        status() {
            return this.$store.state.references.taskStatuses;
        },
        employers() {
            return this.$store.state.references.employers;
        },
        setting() {
            return this.$store.state.preferences.setting;
        },
        filterAlias() {
            return this.$route.meta.filterAlias || 'all';
        },
        filterPreset() {
            const filter = this.filterPresets.filter(item => item.alias === this.filterAlias)[0].filter || {};
            return { ...initialFilterModel, ...filter };
        },
        isAllTaskFilterPresetSet() {
            return this.filterAlias === 'all';
        },
        filterTitle() {
            let result = '';
            for (const field in this.filterModel) {
                if (Object.prototype.hasOwnProperty.call(this.filterModel, field) && this.filterModel[field]) {
                    const getNamesFrom = (obj) => {
                        if (Object.keys(obj).length !== 0) {
                            return (this.fieldsNames[field] + ': ' + this.filterModel[field].map(id => obj.find(item => item.id === id).name).join(' | ') + '; ');
                        } else {
                            return '';
                        }
                    };
                    if (['string', 'object'].includes(typeof this.filterModel[field]) && this.filterModel[field].length) {
                        switch (field) {
                            case 'assigned_user_id':
                            case 'created_user_id':
                                result += getNamesFrom(this.employers);
                                break;
                            case 'status_id':
                                result += getNamesFrom(this.status);
                                break;
                            case 'finished':
                            case 'planned':
                                result += `${this.fieldsNames[field]} : ${this.filterModel[field][0]} по ${this.filterModel[field][1]}; `;
                                break;
                            default:
                                result += (this.fieldsNames[field] + ': ' + this.filterModel[field] + '; ');
                        }
                    }
                }
            }
            return result;
        },
        isExcelButtonVisible() {
            //использовать в задаче реализации экспорта в excel
            return false;
        }
    },
    created() {
        this.columnDefs = [
            {
                headerName: this.fieldsNames.id + ' задачи',
                field: 'id'
            },
            {
                headerName: this.capitalize(this.fieldsNames.status_id),
                field: 'status_id',
                cellRenderer: ({ data }) => data.status ? data.status.name : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.priority),
                field: 'priority',
                cellRenderer: (params) => {
                    let priorityName = 'Неизвестно';
                    let priorityClass = '';
                    switch (params.data.priority) {
                        case localReferences.taskPriorities.low:
                            priorityName = 'Низкий';
                            priorityClass = '';
                            break;
                        case localReferences.taskPriorities.middle:
                            priorityName = 'Средний';
                            priorityClass = 'light-blue';
                            break;
                        case localReferences.taskPriorities.high:
                            priorityName = 'Высокий';
                            priorityClass = 'light-red';
                            break;
                    }

                    return `<span class="${priorityClass}">${priorityName}</span>`;
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.title),
                field: 'title'
            },
            {
                headerName: this.capitalize(this.fieldsNames.assigned_user_id),
                field: 'assigned_user_id',
                cellRenderer: ({ data }) => data.assigned_user ? data.assigned_user.full_name : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.contact_name),
                field: 'contact.name',
                cellRenderer: (params) => {
                    let name = '';
                    if (params.data.related_entity_type === localReferences.entities.deal) {
                        if (params.data.deal && params.data.deal.contact) {
                            name = params.data.deal.contact.name;
                        }
                    } else if (params.data.related_entity_type === localReferences.entities.lead) {
                        if (params.data.lead && params.data.lead.contact) {
                            name = params.data.lead.contact.name;
                        }
                    }

                    return name;
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.contact_phone),
                field: 'contact.phone',
                cellRenderer: (params) => {
                    let contactPhones = [];
                    if (params.data.related_entity_type === localReferences.entities.deal) {
                        if (params.data.deal && params.data.deal.contact && params.data.deal.contact.contact_phones) {
                            contactPhones = params.data.deal.contact.contact_phones;
                        }
                    } else if (params.data.related_entity_type === localReferences.entities.lead) {
                        if (params.data.lead && params.data.lead.contact && params.data.lead.contact.contact_phones) {
                            contactPhones = params.data.lead.contact.contact_phones;
                        }
                    }
                    return contactPhones.reduce((result, item) => result + item.phone + '; ', '').slice(0, -2);
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.entity_address),
                field: 'entity_address',
                sortable: false,
                cellRenderer: (params) => {
                    if (params.data.related_entity_type === localReferences.entities.deal && params.data.deal) {
                        return params.data.deal.address;
                    }
                    if (params.data.related_entity_type === localReferences.entities.lead && params.data.lead) {
                        return params.data.lead.address;
                    }
                    return '';
                }
            },
            {
                headerName: this.capitalize(this.fieldsNames.planned),
                field: 'planned'
            },
            {
                headerName: this.capitalize(this.fieldsNames.related_entity_id),
                field: 'related_entity_id'
            },
            {
                headerName: this.capitalize(this.fieldsNames.created_user_id),
                field: 'created_user_id',
                cellRenderer: ({ data }) => data.created_user ? data.created_user.full_name : ''
            },
            {
                headerName: this.capitalize(this.fieldsNames.finished),
                field: 'finished'
            },
            {
                headerName: '',
                field: '',
                headerComponentFramework: TableHeaderSettings,
                cellRenderer: ({ data }) => this.getLinkElement(data.id, 'div', 'cell-icon'),
                width: 40,
                cellClass: null
            }
        ];
    },
    mounted() {
        this.loadSettings();
    },
    methods: {
        loadSettings() {
            this.$store.dispatch('preferences/getPreferences').then(
                () => {
                    this.setSettings();
                }).catch(() => {
                this.getDataFromServer();
            });
        },
        setSettings() {
            if (this.setting.tasks) {
                this.gridOptions.columnApi.setColumnState(this.setting.tasks.table);
                this.gridOptions.api.setSortModel(this.setting.tasks.sort);
                this.pageModel = JSON.parse(JSON.stringify(this.setting.tasks.page));
                if (this.isAllTaskFilterPresetSet) {
                    this.filterModel = { ...this.setting.tasks.filter, ...this.filterPreset };
                } else {
                    this.filterModel = JSON.parse(JSON.stringify(this.setting.tasks.filter));
                }
                this.resetContactFilter();
            } else {
                this.gridOptions.api.setSortModel({});
            }
        },
        resetContactFilter() {
            this.filterModel.contact_name = null;
            this.filterModel.contact_phone = null;
        },
        hideFilterForm() {
            this.isFilterFormVisible = false;
        },
        getLinkElement(id, elementType, className) {
            const route = {
                name: 'task-card',
                params: { id: id }
            };
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
                element.innerText = id;
            }
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        onSelectionChanged(e) {
            if (e.node.data.related_entity_id && e.node.data.related_entity_type === 'deal') {
                const deal = e.node.data.deal;
                if ((this.$store.getters.isCurrentEmployerMeasurer && deal.measurer_user_id && (this.$store.state.auth.employerId !== deal.measurer_user_id)) ||
                    (this.$store.getters.isCurrentEmployerInstaller && deal.installation_user_id && (this.$store.state.auth.employerId !== deal.installation_user_id))) {
                    this.openTaskCard(e);
                    return;
                }
                const openedTask = {
                    id: e.node.data.id,
                    status_id: e.node.data.status_id,
                    related_entity_id: e.node.data.related_entity_id,
                    related_entity_type: e.node.data.related_entity_type,
                    assigned_user_id: e.node.data.assigned_user_id,
                    created_user_id: e.node.data.created_user_id
                };
                this.$router.push({ name: 'deal-card', params: { id: '' + e.node.data.related_entity_id, openedTask } });
            } else {
                this.openTaskCard(e);
            }
        },

        openTaskCard(e) {
            this.$router.push({ name: 'task-card', params: { id: '' + e.node.data.id } });
        },
        onRowClicked(e) {
            this.onSelectionChanged(e);
        },
        getDataFromServer() {
            const requestParams = {
                size: this.pageModel.pageSize,
                page: this.pageModel.currentPage,
                sort: this.gridOptions.api.getSortModel(),
                filter: this.filterPreset
            };
            if (this.isAllTaskFilterPresetSet) {
                requestParams.filter = this.filterModel;
            }
            this.loading = true;
            this.$store.dispatch('tasks/getPaginatedList', requestParams).then(
                response => {
                    this.gridOptions.api.setRowData(this.tasks);
                    this.pageModel.pageSize = +response.data.meta.per_page;
                    this.pageModel.currentPage = response.data.meta.current_page;
                    this.saveSetting();
                    this.loading = false;
                }).catch(
                error => {
                    console.log(error);
                });
        },
        setPageSize(size) {
            this.pageModel.pageSize = size;
            this.getDataFromServer();
        },
        goNewCard() {
            this.$router.push({ name: 'task-card-new' });
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
            this.getDataFromServer();
        },
        filterApplied() {
            this.isFilterFormVisible = false;
            this.pageModel.currentPage = 1;
            this.getDataFromServer();
        },
        onRowDataChanged() {
            this.totalRows = this.gridOptions.api.getDisplayedRowCount();
        },
        onRowSelected() {
            this.selectedRowsCount = this.gridOptions.api.getSelectedRows().length;
        },
        isColumnVisible(colId) {
            return this.isFilterFormVisible && this.gridOptions.columnApi ? this.gridOptions.columnApi.getColumn(colId).visible : false;
        },
        onDisplayedColumnsChanged() {
            if (this.setting.task) {
                this.saveSetting();
            }
        },
        onColumnResized(data) {
            if (data.finished && data.source === 'uiColumnDragged') {
                this.saveSetting();
            }
        },
        onSortChanged() {
            this.getDataFromServer();
        },
        async saveSetting() {
            const data = {
                'tasks': {
                    'table': this.gridOptions.columnApi.getColumnState(),
                    'sort': this.gridOptions.api.getSortModel(),
                    'filter': this.setting.tasks ? this.setting.tasks.filter : [],
                    'page': this.setting.tasks ? this.setting.tasks.page : []
                }
            };
            if (this.isAllTaskFilterPresetSet) {
                data.tasks.filter = this.filterModel;
                data.tasks.page = this.pageModel;
            }
            await this.$store.dispatch('preferences/setPreferences', data);
        },
        capitalize: capitalize
    },
    watch: {
        filterAlias(value) {
            if (value) {
                if (this.isAllTaskFilterPresetSet) {
                    this.filterModel = { ...this.filterPreset };
                }
                this.pageModel.currentPage = 1;
                this.getDataFromServer();
            }
        }
    }
};
</script>
